import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Input from 'components/forms/Input';


// ====================
// SELECT INPUT
// ====================

export const RadioItem = React.forwardRef(({ name, value, checked, children, onChange }, ref) => (
  <label>
    <input ref={ref} type="radio" name={name} checked={checked} onChange={onChange} />
    <span>{children}</span>
  </label>
))


export const RadioListInput = React.forwardRef(({ className, name, children, ...props }, ref) => (
  <Input
    {...props}
    ref={ref}
    className={cx("radio-list", className)}
    renderInput={inputProps => (
      <div className="radio-item-list">
        { React.Children.map(children, (element, idx) => {
            if(!element)
              return null;
            let onChange = (e) => {
              if(e.target.value === "on")
                inputProps.onChange({ target: {
                  name,
                  value: element.props.value 
                }})
            }
            return React.cloneElement( 
              element, 
              { ...inputProps,
                key: element?.props?.value,
                name,
                onChange,
                value: element?.props?.value,
                checked: element?.props?.value === inputProps.value,},
              element?.props?.children)
              })}
      </div>
    )} />
))
export default RadioListInput;